module.exports = __webpack_public_path__ + "static/media/lock-small-icon.cb9d1edd.svg";